export const EDITOR_THEMES = {
  'vs-dark': { id: 'vs-dark', label: 'VS Code Dark+' },
  'github-dark': { id: 'github-dark', label: 'GitHub Dark' },
  monokai: { id: 'monokai', label: 'Monokai' },
  'one-dark-pro': { id: 'one-dark-pro', label: 'One Dark Pro' },
  'vs-light': { id: 'vs', label: 'Light Theme' },
  'hc-black': { id: 'hc-black', label: 'High Contrast Dark' },
  'hc-light': { id: 'hc-light', label: 'High Contrast Light' },
};

export const DEFAULT_THEME = 'vs-dark';

const GITHUB_DARK = {
  base: 'vs-dark',
  inherit: true,
  rules: [
    { token: 'comment', foreground: '8b949e', fontStyle: 'italic' },
    { token: 'keyword', foreground: 'ff7b72' },
    { token: 'string', foreground: 'a5d6ff' },
    { token: 'number', foreground: '79c0ff' },
    { token: 'type', foreground: 'ffa657' },
    { token: 'function', foreground: 'd2a8ff' },
  ],
  colors: {
    'editor.background': '#0d1117',
    'editor.foreground': '#c9d1d9',
    'editorLineNumber.foreground': '#484f58',
    'editorLineNumber.activeForeground': '#c9d1d9',
    'editor.lineHighlightBackground': '#161b22',
    'editor.selectionBackground': '#264f78',
    'editorCursor.foreground': '#58a6ff',
    'editorBracketMatch.background': '#3fb95033',
    'editorBracketMatch.border': '#3fb950',
    'scrollbarSlider.background': '#484f5833',
    'scrollbarSlider.hoverBackground': '#484f5855',
    'minimap.background': '#0d1117',
  },
};

const MONOKAI = {
  base: 'vs-dark',
  inherit: true,
  rules: [
    { token: 'comment', foreground: '75715E', fontStyle: 'italic' },
    { token: 'keyword', foreground: 'F92672' },
    { token: 'string', foreground: 'E6DB74' },
    { token: 'number', foreground: 'AE81FF' },
    { token: 'type', foreground: '66D9EF' },
    { token: 'function', foreground: 'A6E22E' },
  ],
  colors: {
    'editor.background': '#272822',
    'editor.foreground': '#F8F8F2',
    'editorLineNumber.foreground': '#90908A',
    'editorLineNumber.activeForeground': '#F8F8F2',
    'editor.lineHighlightBackground': '#3E3D32',
    'editor.selectionBackground': '#49483E',
    'editorCursor.foreground': '#F8F8F0',
    'minimap.background': '#272822',
  },
};

const ONE_DARK_PRO = {
  base: 'vs-dark',
  inherit: true,
  rules: [
    { token: 'comment', foreground: '5C6370', fontStyle: 'italic' },
    { token: 'keyword', foreground: 'C678DD' },
    { token: 'string', foreground: '98C379' },
    { token: 'number', foreground: 'D19A66' },
    { token: 'type', foreground: 'E5C07B' },
    { token: 'function', foreground: '61AFEF' },
  ],
  colors: {
    'editor.background': '#282C34',
    'editor.foreground': '#ABB2BF',
    'editorLineNumber.foreground': '#636D83',
    'editorLineNumber.activeForeground': '#ABB2BF',
    'editor.lineHighlightBackground': '#2C313A',
    'editor.selectionBackground': '#3E4451',
    'editorCursor.foreground': '#528BFF',
    'minimap.background': '#282C34',
  },
};

const VS_DARK_PLUS = {
  base: 'vs-dark',
  inherit: true,
  rules: [],
  colors: {
    'editor.background': '#1E1E1E',
    'editor.foreground': '#D4D4D4',
    'editorLineNumber.foreground': '#858585',
    'editorLineNumber.activeForeground': '#C6C6C6',
    'editor.lineHighlightBackground': '#2A2D2E',
    'editor.selectionBackground': '#264F78',
    'editorCursor.foreground': '#AEAFAD',
    'editorBracketMatch.background': '#0064001a',
    'editorBracketMatch.border': '#888888',
    'scrollbarSlider.background': '#79797966',
    'scrollbarSlider.hoverBackground': '#646464b3',
    'minimap.background': '#1E1E1E',
  },
};

export function registerEditorThemes(monaco) {
  monaco.editor.defineTheme('github-dark', GITHUB_DARK);
  monaco.editor.defineTheme('monokai', MONOKAI);
  monaco.editor.defineTheme('one-dark-pro', ONE_DARK_PRO);
  monaco.editor.defineTheme('vs-dark-plus', VS_DARK_PLUS);
}

export function resolveThemeId(themeId) {
  if (themeId === 'vs-dark') return 'vs-dark-plus';
  if (themeId === 'vs-light') return 'vs';
  if (themeId === 'hc-black' || themeId === 'hc-light') return themeId;
  return themeId;
}
